import React, { useState,useEffect, } from 'react';
import { useMutation, gql,useQuery } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import {
    Button,
    Box,
    Typography,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControlLabel,
    Switch,
    Snackbar,
    Alert,
} from '@mui/material';
import useStyles from '../ChangeCustomerType/styles';// You might need a separate style or reuse this
import useGlobalStyles from '../../utils/globalStyles';

export const GET_CUSTOMER_NEST_PASS = gql`
    query GetCustomerNestPass($customerPhone: String!, $skip: Int!, $limit: Int!) {
        getCustomerNestPass(customerPhone: $customerPhone, skip: $skip, limit: $limit) {
            code
            membershipStatus
            lastMembershipType
            lastMembershipPaymentStatus
            refundStatus
        }
    }
`;

export const CANCEL_NEST_PASS_MUTATION = gql`
    mutation CancelNestPass($customerPhone: String!, $reason: String!, $shouldRefund: Boolean) {
        cancelNestPass(customerPhone: $customerPhone, reason: $reason, shouldRefund: $shouldRefund)
    }
`;

function CancelNestPassModal(props) {
    const { open, onClose, customerPhone, refetch } = props;
    const { t } = props;
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    const [cancelReason, setCancelReason] = useState('');
    const [shouldRefund, setShouldRefund] = useState(false);
    const [refundAllowed, setRefundAllowed] = useState(false);
    const isReasonEmpty = cancelReason.trim() === '';

    const { data: customerData, loading: customerLoading } = useQuery(GET_CUSTOMER_NEST_PASS, {
        variables: { customerPhone, skip: 0, limit: 1 },
        skip: !customerPhone, // Skip query if phone is not provided
    });

    const [cancelNestPass, { data: cancelData, loading: cancelLoading, error: cancelError }] = useMutation(CANCEL_NEST_PASS_MUTATION);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    useEffect(() => {
        if (customerData && customerData.getCustomerNestPass) {
            const { membershipStatus, lastMembershipType, lastMembershipPaymentStatus, refundStatus } =
                customerData.getCustomerNestPass;

            // Check refund eligibility
            if (
                membershipStatus === 0 && // MEMBER
                lastMembershipType === 0 && // PURCHASED
                lastMembershipPaymentStatus === 2 && // SUCCESS
                refundStatus === 5 // REFUND_APPLICABLE
            ) {
                setRefundAllowed(true);
            } else {
                setRefundAllowed(false);
            }
        }
    }, [customerData]);

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };

    const handleCancelNestPass = async () => {
        if (isReasonEmpty) {
            setSnackbarSeverity('error');
            setSnackbarMessage(t('Reason for cancellation is required.'));
            setSnackbarOpen(true);
            return;
        }

        const onCompleted = (data) => {
            const message = t('Nest Pass cancelled successfully.');
            setSnackbarSeverity('success');
            setSnackbarMessage(message);
            setSnackbarOpen(true);
    
            if (!props.vendor) setCancelReason(''); // Clear fields if applicable
            if (refetch) refetch(); // Refresh data
    
            setTimeout(() => {
                onClose(); // Close the modal after a delay
            }, 2000); // Adjust the delay as needed
        };
    
        const onError = (err) => {
            const errorMessage = err.message || t('Failed to cancel Nest Pass.');
            setSnackbarSeverity('error');
            setSnackbarMessage(errorMessage);
            setSnackbarOpen(true);
        };
    
        try {
            await cancelNestPass({
                variables: { customerPhone, reason: cancelReason, shouldRefund },
                onCompleted,
                onError,
            });
        } catch (error) {
            onError(error);
        }
    };
    
    
    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="cancel-nest-pass-dialog-title">
            <DialogTitle id="cancel-nest-pass-dialog-title" className={classes.heading}>
                <Typography className={classes.textWhite} variant="h6" component="h2">
                    {t('Cancel Nest Pass')}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                {customerLoading ? (
                    <Typography>{t('Loading customer details...')}</Typography>
                ) : (
                    <>
                        <TextField
                            label={t('Reason for Cancellation')}
                            multiline
                            rows={4}
                            fullWidth
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            margin="normal"
                            required
                            error={isReasonEmpty}
                            helperText={isReasonEmpty ? t('Please enter a cancellation reason.') : ' '}
                            InputLabelProps={{ style: { color: 'black' } }}
                            InputProps={{ style: { color: 'black' } }}
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={shouldRefund}
                                    onChange={(e) => setShouldRefund(e.target.checked)}
                                    name="shouldRefund"
                                    color="primary"
                                    disabled={!refundAllowed}
                                    
                                />
                            }
                            label={refundAllowed ? t('Issue a Refund?') : t('Refund not applicable')}
                            style={{ color: 'black', marginTop: '16px' }} 

                           
                        />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} className={globalClasses.modalCancleBtn}>
                    {t('Cancel')}
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleCancelNestPass}
                    disabled={cancelLoading || isReasonEmpty}
                >
                    {cancelLoading ? t('Cancelling...') : t('Confirm Cancellation')}
                </Button>
            </DialogActions>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Dialog>
    );
}

export default withTranslation()(CancelNestPassModal);
